module.exports = __webpack_public_path__ + "static/media/Licht_ruis.45350f48.mp3";